import React, { useContext, useEffect } from 'react';
import { Switch, HashRouter, useHistory } from 'react-router-dom';
import DashboardRoutes from '../routers/DashboardRoutes';
import Login from '../components/seguridad/Login';
import { PrivateRoutes } from './PrivateRoutes';
import { PublicRoutes } from './PublicRoutes';

import { AuthContext } from '../context/Globales/AuthContext';

import LoginDisable from '../components/seguridad/LoginDisable';

const AppRoutes = () => {
  
  const history = useHistory();
  const { user } = useContext(AuthContext);

  if (JSON.parse(sessionStorage.getItem('pchcllog')) == null && JSON.parse(localStorage.getItem('log'))) {
    localStorage.clear();
  }

  return (
    <>


      <HashRouter history={history}>
        <div>
          <Switch>
            <React.Fragment>

              <PublicRoutes exact path="/login" component={Login} Autenticado={user.logged} />
              {!user.logged ? <PublicRoutes exact path="/integration" component={LoginDisable} Autenticado={user.logged} /> : ''}
              <PrivateRoutes path="/" component={DashboardRoutes} Autenticado={user.logged}  /> {/* este no debe ser exact, sino habran conflictos en la navegacion!!!! */}


            </React.Fragment>
          </Switch>
        </div>
      </HashRouter>

    </>
  );
}

export default AppRoutes;